import { render, staticRenderFns } from "./magazine-generic-text-panel.vue?vue&type=template&id=1683e830&scoped=true&"
var script = {}
import style0 from "../../../../assets/styles/panels/_GenericTextPanel.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./magazine-generic-text-panel.scss?vue&type=style&index=1&id=1683e830&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1683e830",
  null
  
)

export default component.exports